// HomeActionQueue — "What needs you" card matching the prototype's ActionQueue.
//
// Composes a prioritized feed via useHomeActionQueue (urgency-aware
// hook): pending stake decisions, onboarding gaps, recent verified
// wins, Sika progress, cashout watches. No mock data; every item is
// derived from real Supabase state.

import { Link } from "react-router-dom";
import { Icon } from "../../components/icons/Icon.tsx";
import { useHomeActionQueue } from "./useHomeActionQueue.ts";

export function HomeActionQueue(): JSX.Element {
  const { items: queueItems, loading } = useHomeActionQueue(4);

  return (
    <div className="home-card">
      <div className="card-head">
        <div className="h-title">What needs you</div>
        <div className="h-sub">
          · {String(queueItems.length)} item{queueItems.length === 1 ? "" : "s"}
        </div>
        <div className="h-actions">
          <Link className="link" to="/audit">
            All activity <Icon name="chev" size={12} />
          </Link>
        </div>
      </div>
      <div className="card-body queue">
        {loading && queueItems.length === 0 ? (
          <div className="q-empty">Loading…</div>
        ) : queueItems.length === 0 ? (
          <div className="q-empty">
            Nothing needs you right now. Items appear here when a brief, decision, or watch needs
            your attention.
          </div>
        ) : (
          queueItems.map((it) => (
            <div key={it.id} className="q-item">
              <div className={`q-icon ${it.type}`}>
                <Icon name={it.icon} size={14} />
              </div>
              <div className="q-text">
                <div className="t">{it.title}</div>
                <div className="s">{it.body}</div>
              </div>
              <div className="q-time">{it.time}</div>
              <Link to={it.href} className={`q-cta ${it.primary ? "primary" : ""}`}>
                {it.cta}
              </Link>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
